/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useRef } from 'react'
import TextAreaWithSpeech from '../../../Components/common/TextAreaWithSpeechUsingDeepgram';
import { updateJournalToday } from '../../../Components/action/common';
import moment from 'moment';
import { getEditorContent } from '../../../Components/action/utilities';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, RitualIcon } from '../../../Components/LandingHeader/Feedback/icons/Icons';
import { updateJournalList } from '../../../redux/slices/TaskSlice';

const JournalWithoutAI = () => {
    const editorRef = useRef(null);
    const {theme, colorPickerDark, colorPicker} = useSelector(state => state.theme);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const updateJournal = async (e) => {
        e.preventDefault();
        try {
            const value = getEditorContent('description', editorRef);
            let requestBody = {
                "morningReflection": value,
                "date": moment().startOf('date').toISOString()
            }

            await updateJournalToday(requestBody);
            dispatch(updateJournalList(requestBody));
            navigate('/morning-rituals?step=plan-today');
        } catch ({ response }) {}
    }

    return (
        <div className='journal-container self-stretch flex flex-col gap-5 w-full max-w-[800px]'>
            <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                <RitualIcon />
                <div className="flex justify-center text-2xl font-normal font-['RL_Madena'] dark-primary-color-60">Morning Ritual</div>
                <div className="self-stretch justify-center text-2xl font-normal font-['RL_Madena'] dark-primary-color-20">Journal</div>
            </div>
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-10 h-[100vh] mt-[60px] mb-[60px]">
                <div className="self-stretch inline-flex justify-center items-center gap-2.5">
                    <div className="flex-1 justify-center dark:text-white text-black text-4xl font-normal font-['RL_Madena']">Let’s reflect and clear out our minds.</div>
                </div>
                <TextAreaWithSpeech richText={true} placeholder="This prompt encourages you to listen to your body's signals,  which can provide valuable insights about your physical and mental well-being..." ref={editorRef} color={theme === 'dark' ? colorPickerDark : colorPicker} customClass="h-full" onSave={updateJournal} height='h-auto' minHeight='24rem' maxHeight='calc(100vh - 410px)' />
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2.5">
                <div className="flex justify-center items-center gap-2">
                    <Link to="/morning-rituals?step=gratitude" className="px-3.5 py-2.5 bg-white dark:bg-black rounded-[50px] outline outline-1 outline-white/5 flex justify-center items-center gap-2">
                        <ArrowLeft />
                    </Link>
                </div>
                <div className="flex justify-center items-center gap-2">
                    <a href="#" onClick={updateJournal} className="justify-center !text-white text-sm font-medium font-['Inter'] button primary dark-background-color !h-auto line-height-normal" css={{
                    svg:{
                        path:{
                            stroke: 'white !important'
                        }
                    }
                }}>
                        Next <ArrowLeft right={true} />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default JournalWithoutAI;